import { type FC, useRef } from 'react'

import { MegaMenuCategoryTree } from './MegaMenuCategoryTree'
import { MegaMenuL1 } from './MegaMenuL1'
import { useActiveMegaMenu } from './useActiveMegaMenu'

export type MegaMenuProps = {
  locationId: number
}

export const MegaMenu: FC<MegaMenuProps> = ({ locationId }) => {
  const {
    activeL2Items,
    activeL3Items,
    brandedCategoryCampaign,
    closeMenu,
    handleClearTimeout,
    isCollapsedMenuView,
    isKeyboardNavigation,
    l1MenuItems,
    menuBarRef,
    onHover,
    openMenu,
    selectedL1Item,
    selectedL2Item,
  } = useActiveMegaMenu(locationId)

  const selectedL1Ref = useRef<HTMLAnchorElement>(null)

  return (
    <MegaMenuL1
      closeMenu={closeMenu}
      handleClearTimeout={handleClearTimeout}
      isCollapsedMenuView={isCollapsedMenuView}
      l1MenuItems={l1MenuItems}
      menuBarRef={menuBarRef}
      ref={selectedL1Ref}
      onHover={onHover}
      openMenu={openMenu}
      selectedL1Item={selectedL1Item}
    >
      {!!selectedL1Item?.id && (
        <MegaMenuCategoryTree
          activeL2Items={activeL2Items}
          activeL3Items={activeL3Items}
          brandedCategoryCampaign={brandedCategoryCampaign}
          closeMenu={closeMenu}
          handleClearTimeout={handleClearTimeout}
          isCollapsedMenuView={isCollapsedMenuView}
          openMenu={openMenu}
          selectedL1Item={selectedL1Item}
          selectedL2Item={selectedL2Item}
          ref={selectedL1Ref}
          isKeyboardNavigation={isKeyboardNavigation}
        />
      )}
    </MegaMenuL1>
  )
}
